// extracted by mini-css-extract-plugin
export default {"list":"how-familiar_list__+p-t-","arrow_icon":"how-familiar_arrow_icon__XGGaD"};